<template>
  <div>
    <HeroSection />
    <WhyChooseUsSection />
    <ServicesSection/>
    <RegisterationSection />    
    <CallToActionSection />
  </div>
</template>

<script>
import HeroSection from "@/components/HeroSection.vue";
import WhyChooseUsSection from "@/components/WhyChooseUsSection.vue";
import RegisterationSection from "@/components/RegisterationSection.vue";
import CallToActionSection from "@/components/CallToActionSection.vue";
import ServicesSection from "@/components/ServicesSection.vue";


export default {
  name: "HomeView",
  components: {
    HeroSection,
    WhyChooseUsSection,
    ServicesSection,
    RegisterationSection,
    CallToActionSection
  },
};
</script>
